import axios from "axios";

const api = axios.create({
  baseURL: "https://oyster-app-jh7ia.ondigitalocean.app/",
  // baseURL: "http://localhost:8080/",
});

export default api;
